<div class="backdrop" *ngIf="isVisible" (click)="close()" >
<div class="filter_parent-container" (click)="$event.stopPropagation()">
  <div class="offcanvase-filter-content-wrap">
    <div class="offcanvase-filter-title-wrap d-flex space-bet align-center">
      <h5 class="form-sidebar-title">Filter</h5>
      <div class="filter-button-wrap">
        <a class="button btn wpee-filter-reset" href="javascript:void(0); " (click)="clearForm()"
          >Clear Filter</a>
        <input type="submit" name="submit" value="Apply" (click)="apply()"/>
      </div>
    </div>
    <form [formGroup]="form">
      <label>Seeking a:</label>
      <mat-form-field appearance="fill" class="full-width">
        <mat-select formControlName="gender">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let gender of genderOptions" [value]="gender._id">
            {{ gender.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="form-group dob">
        <label>Age:</label>
        <div class="date-selectors">
          <mat-form-field appearance="fill" class="full-width">
            <mat-select formControlName="ageFrom" (selectionChange)="updateAgeToOptions()">
              <mat-option value="">From</mat-option>
              <mat-option *ngFor="let age of ageOptions" [value]="age">
                {{ age }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill" class="full-width">
            <mat-select formControlName="ageTo">
              <mat-option value="">To</mat-option>
              <mat-option *ngFor="let age of filteredAgeOptions" [value]="age">
                {{ age }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <label>Country:</label>
      <mat-form-field appearance="fill" class="full-width">
        <mat-select formControlName="country" (selectionChange)="onCountryChange($event.value)">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let country of Countryoption" [value]="country._id">
            {{ country.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <label>State:</label>
      <mat-form-field appearance="fill" class="full-width">
        <mat-select formControlName="state" (selectionChange)="onStateChange($event.value)">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let state of states" [value]="state._id">
            {{ state.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <label>City:</label>
      <mat-form-field appearance="fill" class="full-width">
        <mat-select formControlName="city">
          <mat-option value="">Select</mat-option>
          <mat-option *ngFor="let city of cities" [value]="city._id">
            {{ city.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-error *ngIf="form.get('city')?.hasError('stateNotSelected')">Please select a state first</mat-error>
      <span class="filter-close"  (click)="close()"> close filter</span>
    </form>
  </div>
</div>
</div>

